import Typography from '@material-ui/core/Typography';
import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';

import useClientAllocationsUpdate from '../../hooks/updateAllocations/useClientAllocationsUpdate';
import layoutStyles from '../../../shared/components/EditAllocationFormLayout/EditAllocationFormLayout.module.scss';
import AllocationClientsSelect from '../SelectFields/AllocationClientsSelect';
import AllocationClientRowItem from '../ClientsRowItem/AllocationClientRowItem';
import useAddAllocationAvailability from '../../hooks/validateAllocations/useAddAllocationAvailability';

// import styles from './AllocationClientsList.module.scss';
// import { useAddClientAllocationContext } from '../../context/AddClientAllocationContext';
// import { useStoreState } from '~/store/hooks';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AllocationClientsList: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const {
    fields: clientsAllocationsFields,
    updateAllocations,
    removeClientAt,
  } = useClientAllocationsUpdate(teamMemberIdx);

  useAddAllocationAvailability({
    clientsAllocations: clientsAllocationsFields.map(alloc => ({
      clientId: alloc.clientId,
      teamId: alloc.teamId ?? alloc.team?.id,
    })),
    userId: teamMember.id,
  });

  return (
    <>
      <Typography variant="subtitle1" className={layoutStyles.assignedClientsSectionTitle}>
        Client Allocations
      </Typography>

      <AllocationClientsSelect
        teamMemberIdx={teamMemberIdx}
        teamMember={teamMember}
        updateAllocations={updateAllocations}
      />

      {clientsAllocationsFields.map((field, clientIdx) => (
        <AllocationClientRowItem
          key={field.id}
          field={field}
          clientIdx={clientIdx}
          teamMemberIdx={teamMemberIdx}
          memberId={teamMember.id}
          onRemove={removeClientAt}
        />
      ))}
    </>
  );
};

export default AllocationClientsList;
